import { Controller } from "@hotwired/stimulus"
import debounce from "lodash/debounce"

export default class extends Controller {
  static targets = ["input", "hidden", "results", "market"]
  static values = {
    url: { type: String, default: "/admin/courses/autocomplete" },
    latitude: { type: Number },
    longitude: { type: Number }
  }

  connect() {
    this.fetchCourses = debounce(this.fetchCourses.bind(this), 300)
  }

  disconnect() {
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout)
    }
  }

  async search() {
    const query = this.inputTarget.value.trim()
    if (query.length >= 3) {
      await this.fetchCourses(query)
    } else {
      if (query.length === 0) {
        this.hiddenTarget.value = ""
      }
      this.clearResults()
    }
  }

  async fetchCourses(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.append("q", query)
    if (this.hasMarketTarget && this.marketTarget.value) {
      url.searchParams.append("market_id", this.marketTarget.value)
    }
    if (this.hasLatitudeValue && this.hasLongitudeValue) {
      url.searchParams.append("lat", this.latitudeValue)
      url.searchParams.append("lng", this.longitudeValue)
    }

    try {
      const response = await fetch(url.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
      const html = await response.text()
      this.resultsTarget.innerHTML = html
      this.resultsTarget.hidden = false
      this.bindOptionClicks()
    } catch (error) {
      console.error("Course autocomplete error:", error)
      this.clearResults()
    }
  }

  bindOptionClicks() {
    this.resultsTarget.querySelectorAll("[data-course-id]").forEach((el) => {
      if (el.classList.contains("autocomplete-empty")) return

      const courseId = el.dataset.courseId
      const courseName = el.dataset.courseName

      el.addEventListener("click", (e) => {
        e.preventDefault()
        this.selectCourse(courseId, courseName)
      })

      el.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          this.selectCourse(courseId, courseName)
        }
      })
    })
  }

  selectCourse(courseId, courseName) {
    this.hiddenTarget.value = courseId
    this.inputTarget.value = courseName
    this.clearResults()
    this.resultsTarget.hidden = true
  }

  clearResults() {
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.hidden = true
  }

  inputBlur() {
    this.blurTimeout = setTimeout(() => {
      this.clearResults()
    }, 200)
  }

  inputFocus() {
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout)
      this.blurTimeout = null
    }
  }
}
